import { mapActions, mapGetters } from "vuex";
import { globalLoader } from "@/helpers/variables";

import CustomPagination from "@/components/custom-pagination/index.vue";
import BeforeAfterInfo from "@/modules/pages/before-after-catalog/components/before-after-info/index.vue";
import CatalogItem from "@/modules/pages/before-after-catalog/components/catalog-item/index.vue";

import { Flicking } from "@egjs/vue-flicking";
import "@egjs/vue-flicking/dist/flicking.css";


export default {
  name: "BeforeAfterCatalog",
  components: { CatalogItem, BeforeAfterInfo, CustomPagination, Flicking },

  data() {
    return {
      windowSize: window.innerWidth,
      page: 1,
      perPage: 8,
      total: 0,
      flickingOptions: {
        horizontal: true,
        circular: true,
        align: "prev",
        duration: 600,
        moveType: "snap",
        panelsPerView: 2,
        gap: 12,
        useFractionalSize: true,
        resizeOnContentsReady: true,
      },
    };
  },

  computed: {
    ...mapGetters({
      caseDetail: "beforeAfter/caseDetail",
    }),

    isMobile() {
      return this.windowSize <= 768;
    },

    categorySlug() {
      return this.$route.query.category;
    },

    caseSlug() {
      return this.$route.query.case;
    },

    currentCategoryName() {
      return this.caseDetail?.category?.name || null;
    },

    products() {
      return this.caseDetail?.products?.data || [];
    },

    productsMeta() {
      return this.caseDetail?.products?.meta || null;
    },
  },

  mounted() {
    window.addEventListener("resize", this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },

  watch: {
    page() {
      if (!this.isMobile) this.fetchDetail();
    },

    caseSlug() {
      this.page = 1;
      this.fetchDetail(true);
    },

    isMobile(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.page = 1;
        this.fetchDetail(true);
      }
    },
  },

  methods: {
    ...mapActions({
      fetchCaseDetail: "beforeAfter/FETCH_BEFORE_AFTER_CASE_DETAIL",
    }),

    handleResize() {
      this.windowSize = window.innerWidth;
    },

    async fetchDetail(reset = false) {
      try {
        globalLoader(true);

        if (reset) {
          this.$store.commit("beforeAfter/RESET_BEFORE_AFTER_CASE_DETAIL");
        }

        const productsPerPage = this.isMobile ? 9999 : this.perPage;
        const page = this.isMobile ? 1 : this.page;

        await this.fetchCaseDetail({
          categorySlug: this.categorySlug,
          caseSlug: this.caseSlug,
          productsPerPage,
          load: this.isMobile ? "all" : "paginate",
          page,
        });

        this.total = this.isMobile ? 0 : this.productsMeta?.total || 0;
      } catch (e) {
        console.error("ERROR FETCHING CASE DETAIL:", e);
      } finally {
        globalLoader(false);
      }
    },
  },

  async created() {
    await this.fetchDetail(true);
  },
};

